import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { TestService } from 'src/app/services/test.service';

@Component({
  selector: 'app-info',
  templateUrl: './info.component.html',
  styles: [
  ]
})

export class InfoComponent implements OnInit {
  @ViewChild('info') info: ElementRef;

  public texts;
  constructor(private testService:TestService) { 
    this.testService.getTexts().subscribe(
      resp=>{
        this.texts = resp;
      },
      err=>console.log(err)
    )
  }

  ngOnInit(): void {
  }

  ngAfterViewInit(){
    this.testService.getTexts().subscribe(
      resp=>{
        this.texts = resp;
        setTimeout(()=>{
          this.info.nativeElement.innerHTML = this.texts.info;
        }, 500)
      },
      err=>console.log(err)
    )    

  }

}
